import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import {
  IpStaticSubscriptionDetailsGQL,
  IpStaticSubscriptionDetailsQuery,
} from "../../../../apis/networkdashboard/graphql/graphql";
import { SubscriptionPageComponent } from "../../../../components/subscription-detail/subscription-page/subscription-page";
import { IpStaticSubscriptionDetails } from "../../types";
import { GenericSubscription } from "../generic-subscription";
import { IpSubscriptionViewComponent } from "./ip-subscription-view";

@Component({
  selector: "ip-static-subscription",
  templateUrl: "ip-static-subscription.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IpSubscriptionViewComponent, SubscriptionPageComponent],
})
export class IpStaticSubscriptionComponent extends GenericSubscription<
  IpStaticSubscriptionDetailsQuery,
  IpStaticSubscriptionDetails
> {
  protected query = inject(IpStaticSubscriptionDetailsGQL);

  protected onQuerySuccess(data: IpStaticSubscriptionDetailsQuery): IpStaticSubscriptionDetails {
    return data.ipStaticDetails;
  }
}
